import React from 'react';
import { createValidationErrors, Textarea, Validation } from 'ui';
import { Tag } from 'app/components/tag';
import { Value } from 'app/types-shared';
import { routeConstants } from 'app/routes/route-constants';
import * as navigate from 'app/area/shared/navigation';

import { maxLengthText } from '../../../constants';
import { TextSearchData } from '../types-store';
import { TextListItem } from './types';
import { getTextDataId } from './get-text-data-id';
import { itemPropsAreEqual } from './item-props-are-equal';

import styles from './text-list-tile.scss';

const getDescription = (value: Value) => value ? value.d : undefined;

export const TextListTile: TextListItem = React.memo(({
  textData = {} as TextSearchData,
  modifiedText, modifyText, edited, validationMessages, translation
}) => {

  const onClick = () => {
    navigate.to(routeConstants.textConfigurationItemFor(textData.id, textData.textSet?.v));
  };

  const hasErrors = (validationMessages?.length ?? 0) > 0;
  const validation = hasErrors ? createValidationErrors(validationMessages) : undefined;

  return <div className={hasErrors ? `has-danger ${styles.error}` :
    edited ? styles.edited : undefined}>
    <div className={styles.active} onClick={onClick}>
      <div className={styles.id}>#{textData.id}</div>
      <Tag className={styles.language}>{getDescription(textData.language)}</Tag>
      <div className={styles.textset}>{getDescription(textData.textSet)}</div>
      <Textarea
        className={undefined}
        componentId={`original_text_${getTextDataId(textData)}`}
        label={{ text: translation.original_text }}
        value={textData.originalText}
        readOnly={true}
      />
    </div>
    <Textarea
      className={undefined}
      componentId={`text_${getTextDataId(textData)}`}
      label={{ text: translation.text }}
      value={modifiedText !== undefined ? modifiedText : textData.text}
      onChange={modifyText}
      maxLength={maxLengthText}
      wait={500} />
    {hasErrors && <Validation level={validation.level} messages={validation.messages} />}
  </div>;
}, itemPropsAreEqual);
